import { render, staticRenderFns } from "./MessageDetailContent.vue?vue&type=template&id=504e73d4&scoped=true"
import script from "./MessageDetailContent.vue?vue&type=script&lang=js"
export * from "./MessageDetailContent.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailContent.vue?vue&type=style&index=0&id=504e73d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e73d4",
  null
  
)

export default component.exports